module.exports = __webpack_public_path__ + "img/GHB.f6768d5a.png";